import { Component, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { map, mergeMap, shareReplay, switchMap } from "rxjs/operators";
// import { Notification } from "../../interfaces/notification";
import { Router, NavigationEnd } from "@angular/router";
import { getCurrentWindow } from "@tauri-apps/api/window";
import { map as _map } from "lodash";
import { DOWNLOAD_LOGS_HREF, navItems } from "../../_nav";
import { ApiFileService } from "../../services/api-file.service";
import { AdsService } from "../../services/ads.service";
import { AuthService } from "../../services/auth.service";
import { LicenseService } from "../../services/license.service";
import { MessagingService } from "../../services/messaging.service";
import { ScheduleService } from "../../services/schedule.service";
import { SiteService } from "../../services/site.service";
import { TierService } from "../../services/tier.service";
import { TournamentService } from "../../services/tournament.service";
import { UserService } from "../../services/user.service";
import { StatsService } from "../../services/stats.service";

// Moment
import { ShepherdService } from "angular-shepherd";
import moment from "moment-timezone";
import { NgxSpinnerService } from "ngx-spinner";
import { BehaviorSubject, combineLatest, concat, from, Observable, of, Subject, Subscription, zip } from "rxjs";
import { take } from "rxjs/operators";
import { loading, wrapDoneValue } from "../../../pipe/withLoading/withLoading";
import { NotificationConfig } from "../../interfaces/v2/notification_config";
import { environment } from "../../../environments";
import { User } from "../../interfaces/user";
import { Tier, TierLicense } from "../../interfaces/v2/tier";
import {
  NotificationService,
  RegisterStatus,
} from "../../services/notification.service";
import Cookies from "../../utils/cookies";
import { ThemeService } from '../../services/theme.service';
import { tour, tourRebalance, tourManageFilters } from "./tour-guide";
import posthog from "posthog-js";
import { Store } from "@tauri-apps/plugin-store";
import { emit } from "@tauri-apps/api/event";
import { Native } from "../../../native";
import { IsFeatureEnable } from "../../utils/experiments";
import {
  normalizeAutoCloseLateReg,
  pickNotificationOptionsSource,
} from "../../utils/notification-options";
import { NativeUpdater } from "../../../native/updater";
import { ToastrService } from "ngx-toastr";
import { Options } from '@angular-slider/ngx-slider';
import { CdkDragDrop, moveItemInArray, CdkDragEnter } from '@angular/cdk/drag-drop';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {NativeSharedStorage} from '../../../native/shared';
import { publishSessionContext } from '../../services/session-context';
import { GrindModeLocalStorage } from '../../utils/grind-mode-local-storage';
import { offlineBanner$ } from "../../services/error-handler.util";
import {
  TimeFormatPreference,
  getUserTimeFormatPreference,
  setUserTimeFormatPreference,
} from "../../utils/time-format-preference";
import {
  GGPOKER_NOTICE_URL,
  openNativeExternal,
  shouldShowGgpokerDesktopNotice,
} from "./ggpoker-desktop-notice";
moment().tz("America/Los_Angeles").format();

@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
  styleUrls: ["./default-layout.component.scss"],
  providers: [
    ScheduleService,
    MessagingService,
    UserService,
    AuthService,
    LicenseService,
    TranslateService,
    ShepherdService,
  ]
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  @ViewChild("modalNotificationOptions") modalNotificationOptions: TemplateRef<any>;
  @ViewChild("modalPreferences") modalPreferences: TemplateRef<any>;
  @ViewChild("editNotificationModal") editNotificationModal: TemplateRef<any>;
  @ViewChild("modalBlinds") modalBlinds: TemplateRef<any>;
  @ViewChild("modalStarterWizard") modalStarterWizard: TemplateRef<any>;

  modalRef: BsModalRef;
  private modalHiddenSub: Subscription;

  currentYear: number = new Date().getFullYear();

  public numNotifications = 0;

  public sidebarMinimized = true;
  public isShopSidebarVisible = false;
  public navItems: typeof navItems = [];
  public mainMarginRight = "0";
  public sideMarginRight = "-250px";
  public schedulesFN = [];

  public tourHover = false;
  public tourOptionsOpen = false;

  public tableZoom = localStorage.getItem("table-zoom")
  ? parseFloat(parseFloat(localStorage.getItem("table-zoom")).toFixed(1))
  : 1;

  public notificationBellContent = {
    count: 0,
    items: [],
  };

  public notificationBellOpen = false;

  public userName: string;
  public userEmail: string;

  public licenseType: string;
  public slots: number;
  public selfLicense: boolean;
  public isFreeLocked = false;
  public isFullLocked = false;

  public tierLicense: any = null;

  public isUserVerified: boolean = false;
  public identityUrl = environment.IDENTITY_URL;

  // Snackbar Message
  public showSnackbar = false;
  public snackbarMessage = "";

  public notifications: Notification[] = [];
  public confirmDelete: number;

  private defaultNotificationOptions = {
    enabled: true,
    sound_enabled: true,
    sound: "default",
    sound_volume: 50,
    sound_speed: 1.0,
    badges: {
      site: true,
      start: true,
      priority: true,
      lateReg: true,
      speed: true,
      players: true,
      variant: true,
      prizePool: true,
      game: true,
      blind: true,
    },
    badges_order: [
      "site",
      "start",
      "priority",
      "lateReg",
      "speed",
      "players",
      "variant",
      "prizePool",
      "game",
      "blind",
    ],
    ignore_grind_skiped: false,
    ignore_grind_playing: false,
    auto_close_after: 30,
    auto_close_late_reg: null as number | null,
    close_on_play: false,
  };
  public notificationOptions = this.defaultNotificationOptions;

  public notificationOptionsTab = "general";

  public closeWindowBehavior: 'tray' | 'close' = 'tray';
  public offlineBanner = false;
  private offlineBannerSub: Subscription;

  // Map keys to display labels
  badgeLabels: { [key: string]: string } = {
    site: 'site',
    start: 'start',
    priority: 'priority',
    lateReg: 'late_register',
    speed: 'speed',
    players: 'players',
    variant: 'variant',
    prizePool: 'prize_pool',
    game: 'game',
    blind: 'blind'
  };

  // Array for drag and drop
  badgeItems = [];

  public optionsNotificationVolume: Options = {
    step: 1,
    floor: 0,
    ceil: 100,
    showSelectionBar: true,
  }

  public userData: User = null;
  public isMaster: boolean = false;

  public isDarkTheme = Cookies.get("theme-ui")
    ? JSON.parse(Cookies.get("theme-ui"))
    : true;

  public roles: Set<string> = new Set();
  public team: string;
  public tierId: number;

  private refreshTierData = new BehaviorSubject<void>(null);
  public allowNewTier$: Observable<boolean>;
  public tierList$: Observable<{tiers: Tier[], freeAvailable: boolean}>;
  public tierLicense$: Observable<TierLicense>;

  public mySubText$: Observable<string>;

  notificationStatus$: Observable<RegisterStatus>;

  newTierName: string = "";

  public tierSearch: string = "";

  public userCount: number = 0;

  public tierToDelete = { id: null, name: "" };
  public confirmDeletionText = "";

  public defaultTier = -1;
  public showTitleBar = false;

  unsubList: (() => void)[] = [];

  private updateNotifcationConfigSubject = new Subject<number[]>();
  public updateNotificationConfig$ = this.updateNotifcationConfigSubject.pipe(
    switchMap((list) =>
      concat(
        loading(),
        zip(this.notificationService.getScheduleNotification(list)).pipe(
          map((e) => {
            const query = e[0];
            if (!query || !query[0]) {
              return {
                data: {
                  notifications: [
                    {
                      ids: null,
                      schedules: list,
                      notification: null,
                      notification_type: "none",
                    },
                  ],
                  priority: null,
                  comment: null,
                },
                id_list: list,
              };
            }
            const out: NotificationConfig = {
              notifications: [],
              priority: query[0].priority,
              comment: query[0].comment,
            };

            query.map((sch) => {
              if (sch.priority != query[0].priority) {
                out.priority = null;
              }

              if (sch.comment != query[0].comment) {
                out.comment = null;
              }

              if (sch.notifications) {
                sch.notifications.map((not) => {
                  not.schedule = sch.schedule_id;
                  if (not.notification_type == "at" && not.notification != null) {
                    not.notification = this.getNotificationTime(not.notification);
                  } else if (not.notification_type == "") {
                    not.notification_type = "none";
                  }
                  out.notifications.push(not);
                });
              }
            });

            if (out.notifications.length > 0) {
              const helper = {};
              out.notifications = out.notifications.reduce(function (r, o) {
                const key = o.notification + "-" + o.notification_type;

                if (!helper[key]) {
                  helper[key] = Object.assign(
                    {},
                    {
                      ids: [o.id],
                      schedules: [o.schedule],
                      notification: o.notification,
                      notification_type: o.notification_type,
                    }
                  );
                  r.push(helper[key]);
                } else {
                  helper[key].schedules.push(o.schedule);
                  helper[key].ids.push(o.id);
                }

                return r;
              }, []);
            } else {
              out.notifications = [
                {
                  ids: null,
                  schedules: list,
                  notification: null,
                  notification_type: "none",
                },
              ];
            }

            return { data: out, id_list: list };
          }),
          wrapDoneValue()
        )
      )
    )
  );

  public editingScheduleName = "";
  public editingScheduleId: number = null;
  public editingTournamentId: number = null;
  public editingInitStacks: number = null;
  public replicateNotification = true;
  public replicatePriority = true;
  public schComment = null;
  public commentReflectAll = true;
  public registerTime = null;
  public originalRegisterTime = null;
  public registerTimeMap: { [key: number]: string } = {};
  public registerReflectAll = true;
  public registerSetNotification = false;
  public maxRebuy = null;
  public maxRebuyReflectAll = true;
  public setRegTimeFromNotification = true;
  public notificationTimeChanged = false;
  public editingIds = [];
  public currNotis = null;
  public showTimeSelect = false;
  public structures = [];
  public selectedStructure: any = null;
  public selectedNot: any = {};
  public currentIndexStructure = -1;
  private updatingSchedule: { data: any; id_list: number[] } = { data: {}, id_list: [] };
  private structureModal: BsModalRef;
  private regTimeDebouncer: any;

  /* public get newNotifications(): Notification[] {
    return this.notifications.filter((notification) => !notification.viewed);
  } */

  public showUpdateIcon = false;
  public isUpdateReady = false;
  public updateDownloadProgress = "";
  public updateError = "";

  private readonly emptyAd = {
    id: null,
    title: "",
    image: "",
    link: "",
    position: "",
    start: "",
    finish: "",
    state: "disabled",
  };

  private chatConfig = {
    chatbotId: "vs3v-eVqjIFa49yVS7T-0",
    domain: "www.chatbase.co",
    scriptUrl: "https://www.chatbase.co/embed.min.js"
  };

  private chatDisabledPages: string[] = ['/embedded'];
  private chatScriptLoaded = false;

  public featureTextResize$ = IsFeatureEnable("text-size-change");
  public isWindowMaximized: boolean;
  public timeFormat: TimeFormatPreference = getUserTimeFormatPreference();

  public starterWizardStep = 0;
  public starterWizardTotalSteps = 5;
  public starterWizardLoading = false;
  public starterWizardDone = false;
  public starterWizardCreatedFilterName = "";
  private starterWizardCreatedTier: Tier | null = null;
  public starterWizardSiteOptions: Array<{ id: number; name: string }> = [];
  public starterWizardAnswers = {
    siteIds: [] as number[],
    buyInMin: null as number | null,
    buyInMax: null as number | null,
    prizePoolMin: null as number | null,
    prizePoolMax: null as number | null,
    speeds: [] as string[],
    players: [] as string[],
    types: [] as string[],
    variants: [] as string[],
    weekDays: [] as number[],
  };

  public starterSpeedOptions = ["Regular", "Turbo", "Hyper-Turbo", "Slow"];
  public starterPlayersOptions = ["7 to 10 (Full Ring)", "6-Max", "3 to 5-Max", "2 (Heads Up)"];
  public starterTypeOptions = ["Regular", "Satellite", "Flight"];
  public starterVariantOptions = ["Regular", "Knockout", "Mystery"];
  public starterWeekDayOptions = [
    { id: 0, key: "sunday" },
    { id: 1, key: "monday" },
    { id: 2, key: "tuesday" },
    { id: 3, key: "wednesday" },
    { id: 4, key: "thursday" },
    { id: 5, key: "friday" },
    { id: 6, key: "saturday" },
  ];

  constructor(
    public auth: AuthService,
    private userService: UserService,
    private siteService: SiteService,
    private notificationService: NotificationService,
    private adsService: AdsService,
    private licenseService: LicenseService,
    private tierService: TierService,
    private translateService: TranslateService,
    private statsService: StatsService,
    private spinner: NgxSpinnerService,
    private guideTour: ShepherdService,
    private router: Router,
    private toastService: ToastrService,
    private modalService: BsModalService,
    private themeService: ThemeService,
    private scheduleService: ScheduleService,
    private tournamentService: TournamentService,
    private ngZone: NgZone,
    private apiFileService: ApiFileService
  ) {
    this.notificationStatus$ = this.notificationService.getRegistrationStatus();
  }

  private initializeBadgeItems() {
    this.badgeItems = Object.keys(this.notificationOptions.badges).map(key => ({
      key,
      label: this.badgeLabels[key] || key,
      enabled: this.notificationOptions.badges[key]
    }));

    if (this.notificationOptions.badges_order) {
      const orderedKeys = this.notificationOptions.badges_order
      const orderedItems = [];

      orderedKeys.forEach(key => {
        const found = this.badgeItems.find(item => item.key === key);
        if (found) orderedItems.push(found);
      });

      this.badgeItems = [...orderedItems, ...this.badgeItems.filter(item =>
        !orderedKeys.includes(item.key)
      )];
    }
  }

  drop(event: CdkDragDrop<[]>) {
    moveItemInArray(this.badgeItems, event.previousIndex, event.currentIndex);
    this.updateBadgeState();
  }

  entered(event: CdkDragEnter) {
    moveItemInArray(this.badgeItems, event.item.data, event.container.data);
    this.updateBadgeState();
  }

  toggleBadge(badge) {
    badge.enabled = !badge.enabled;
    this.updateBadgeState();
  }

  private updateBadgeState() {
    this.badgeItems.forEach(item => {
      this.notificationOptions.badges[item.key] = item.enabled;
    });

    this.changeNotificationOptions();
  }

  async changeNotificationOptions() {
    this.notificationOptions.badges_order = this.badgeItems.map(i => i.key);
    const duration = Number(this.notificationOptions.auto_close_after);
    if (!Number.isFinite(duration) || duration < 1) {
      this.notificationOptions.auto_close_after = this.defaultNotificationOptions.auto_close_after;
    } else {
      this.notificationOptions.auto_close_after = Math.min(999, Math.round(duration));
    }

    if (this.notificationOptions.auto_close_late_reg !== null) {
      this.notificationOptions.auto_close_late_reg = normalizeAutoCloseLateReg(
        this.notificationOptions.auto_close_late_reg
      );
    }

    localStorage.setItem("notifications-options", JSON.stringify(this.notificationOptions));
    await this.saveNotificationOptionsToStore();
  }

  async changeCloseWindowBehavior() {
    await this.saveNotificationOptionsToStore();
  }

  public readonly ggpokerNoticeUrl = GGPOKER_NOTICE_URL;

  isNativeMode(): boolean {
    return Native.IsNative();
  }

  showGgpokerNotice(): boolean {
    return shouldShowGgpokerDesktopNotice(this.isNativeMode());
  }

  private async saveNotificationOptionsToStore() {
    if (!Native.IsNative()) return;
    try {
      const store = await Store.load("config.json");
      await store.set("notifications-options", this.notificationOptions);
      await store.set("close-window-behavior", this.closeWindowBehavior);
      await store.save();
      // Small delay to ensure store is written before emitting
      await new Promise(resolve => setTimeout(resolve, 50));
      await emit("store-updated", { key: "notifications-options" });
    } catch (error) {
      console.error("Tauri store operation failed:", error);
    }
  }

  public selectLanguage(lang: string) {
    this.translateService.use(lang);
    Cookies.set("lang", lang, { expires: 365 });
  }

  public getCurrentLang() {
    return this.translateService.currentLang;
  }

  toggleAside() {
    if (this.mainMarginRight == "250px") {
      this.mainMarginRight = "0";
      this.sideMarginRight = "-250px";
    } else {
      this.mainMarginRight = "250px";
      this.sideMarginRight = "0";
    }
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logout() {
    posthog.reset();
    this.auth.logout();
  }

  showSnackMessage(msg: string) {
    this.snackbarMessage = msg;
    this.showSnackbar = true;
    setTimeout(() => {
      this.showSnackbar = false;
    }, 5000);
  }

  utcToLocal(date: string) {
    const dt = moment(date).format();
    return dt;
  }

  getHasPendingRequests() {
    this.userService
      .getPendingRequest()
      .pipe(take(1))
      .subscribe((has_pending_requests) => {
        if (this.isMaster && has_pending_requests) {
          this.notificationBellContent.count = 1;
          this.notificationBellContent.items = [
            `${this.translateService.instant("has_pending_requests")}`,
          ];
          setTimeout(() => this.getHasPendingRequests(), 10000);
        } else {
          this.notificationBellContent.count = 0;
          this.notificationBellContent.items = [];
        }
      });
  }

  async getCurrentUser() {
    const user = this.auth.user;
    this.userName = user.name;
    this.userEmail = user.email;
    this.isUserVerified = user.is_verified;
    const data = await this.userService.getCurrentUser().toPromise();
    const roles = new Set(
      (data.role || "").split(",").map((e) => e.trim().toUpperCase())
    );
    this.roles = roles;
    this.team = data.team;
    this.tierId = data.tier_id;
    NativeSharedStorage.setItem("tier_id", this.tierId.toString());
    this.userData = data;
    this.isMaster = roles.has("MASTER");
    if (this.isMaster) {
      this.getHasPendingRequests();
    }
  }

  async organizeMenuItems() {
    const userData: any = this.userData;
    userData.slots = this.slots;

    this.navItems = navItems
      .filter((e) => !e.role || e.role.some((r) => this.roles.has(r)))
      .filter((e) => !e.filter || e.filter(userData));
      this.navItems.forEach((item) => {
        item.attributes = item.attributes || {};

        if (this.bloquedFunctions && !item.isFree) {
          item.attributes.disabled = true;
        }

        if (item.i18nkey == "tournaments") {
          item.attributes.class = "tournaments-page";
        } else if (item.i18nkey == "manage_schedules") {
          item.attributes.class = "schedule-page";
        } else if (item.i18nkey == "rebalance_schedule") {
          item.attributes.class = "rebalance-page";
        } else if (item.i18nkey == "manage_filters") {
          item.attributes.class = "manage-filters-page";
        }

        if (item.i18nkey !== undefined) {
          item.name = this.translateService.instant(item.i18nkey);
        }
    });
  }

  async goToShopUrl() {
    if (!this.router.url.startsWith("/buy")) {
      this.router.navigate(["/buy"]);
    }
  }

  async goToTierLicenseErr() {
    if (!this.router.url.startsWith("/no-license")) {
      this.router.navigate(["/no-license"]);
    }
  }

  async getUserLicense() {
    const license = await this.licenseService.getLicense();
    this.licenseType = license.license;
    this.slots = license.slots;
    this.selfLicense = license.self;
    this.isFreeLocked = await this.licenseService.isFreeLocked();
    this.isFullLocked = await this.licenseService.isFullLocked();
  }

  get bloquedFunctions(): boolean {
    return !this.licenseType || this.licenseType === "";
  }

  async sendValidation() {
    const resp = await this.userService.sendValidation().toPromise();
    if (resp.ok) {
      return;
    }
  }

  /*   async getNotifications() {
      this.notifications = await this.notificationService.get().toPromise().then((data) => data.filter((notification) => {
        const now = moment()
        const then = moment(notification.date)
        return then.isSameOrAfter(now, "minute")
      }))
    } */

  formatDate(d: string) {
    const date = new Date(d);
    return `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
  }

  formatDateFull(date: Date) {
    return new Date(date).toLocaleString();
  }

  /*   async viewNotifications() {
      await this.notificationService
        .view(this.notifications.map((notification) => notification.id))
        .toPromise();
      this.getNotifications();
    }

    async deleteNotification(id: number) {
      if (this.confirmDelete == id) {
        await this.notificationService.dismiss([id]).toPromise();
        this.confirmDelete = undefined;
        this.getNotifications();
      } else {
        this.confirmDelete = id;
      }
    }

    async handleAction(notification: Notification, action: string) {
      await this.notificationService.handleAction(notification, action);
      this.getNotifications()
    } */

  onSidebarClick(event: MouseEvent) {
    const link = (event.target as HTMLElement | null)?.closest("a");
    if (link?.getAttribute("href") === DOWNLOAD_LOGS_HREF) {
      event.preventDefault();
      void this.downloadLog();
    }
  }

  async downloadLog() {
    try {
      await this.apiFileService.download(environment.API_URL + "v2/log/download", "log.csv");
    } catch (err) {
      console.error("[DOWNLOAD] log download failed", err);
      this.toastService.error(this.translateService.instant("download_failed"));
    }
  }

  WindowResize(e: Event) {
    if (this.isShopPage()) {
      const target = e?.target as HTMLElement;
      if (target?.closest(".navbar-toggler")) {
        this.isShopSidebarVisible = !this.isShopSidebarVisible;
      }
    }

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

  async ngOnInit() {
    this.offlineBannerSub = offlineBanner$.subscribe((banner) => {
      this.offlineBanner = banner;
    });

    this.showTitleBar = Native.IsMainWindow();
    if (this.showTitleBar) {
      this.isWindowMaximized = await getCurrentWindow().isMaximized();
      const win = getCurrentWindow();
      win.onResized(async () => {
        this.isWindowMaximized = await win.isMaximized();
      });
      Native.setDecoration(false);
      addEventListener("beforeunload", () => {
        Native.setDecoration(true);
      });

      const header = document.querySelector("app-header");
      header?.addEventListener("mousedown", (e: MouseEvent) => {
        if (e.target !== header) {
          return;
        }
        const appWindow = getCurrentWindow();
        if (e.buttons === 1) {
          // Primary (left) button
          e.detail === 2
            ? appWindow.toggleMaximize() // Maximize on double click
            : appWindow.startDragging(); // Else start dragging
        }
      });

      const startDownload = () => {
        this.updateDownloadProgress = "";
        NativeUpdater.startDownload().then((isReady) => {
          console.log(isReady);
          if (isReady) {
            this.isUpdateReady = true;
          }
        });
      };

      this.unsubList.push(
        await NativeUpdater.listenDownloadProgress((e) => {
          if (e.type == "progress") {
            this.updateDownloadProgress =
              e.percent == -1
                ? "Downloading"
                : (e.percent * 100).toFixed(2) + "%";
          } else if (e.type == "error") {
            this.updateError = e.error;
            setTimeout(() => {
              // Retry in 1 min
              this.updateError = "";
              startDownload();
            }, 1000 * 60);
          } else if (e.type == "complete") {
            this.isUpdateReady = true;
          }
        })
      );

      this.unsubList.push(
        await NativeUpdater.listenAvailableUpdate(() => {
          this.showUpdateIcon = true;
          startDownload();
        })
      );
      this.showUpdateIcon = await NativeUpdater.hasUpdateAvailable();
      if (this.showUpdateIcon) {
        startDownload();
      }

      const unlisten = await getCurrentWindow().listen<string>('open-notification-options', (event) => {
        this.openNotificationOptionsModal();
        getCurrentWindow().requestUserAttention(1);
      });
      this.unsubList.push(unlisten);

      const unlistenPlayTournament = await getCurrentWindow().listen<any>('play-tournament', (event) => {
        this.handlePlayTournamentEvent(event.payload);
      });
      this.unsubList.push(unlistenPlayTournament);

      const unlistenEditNotification = await getCurrentWindow().listen<any>('edit-notification', (event) => {
        this.ngZone.run(() => this.openEditFromNotification(event.payload));
      });
      this.unsubList.push(unlistenEditNotification);
    }

    if (this.isDarkTheme) {
      this.toggleUITheme();
    }

    if (!this.auth.isLoggedIn()) {
      this.auth.login();
      return;
    }

    const user = this.auth.user;
    if (user) {
      await this.getUserLicense();
      await this.getCurrentUser();

      posthog.identify(user.id.toString(), {
        email: user.email,
        name: user.name,
      });
      if (this.auth.consumeSignIn()) {
        posthog.capture("user_signed_in", { license: this.licenseType || "free" });
      }
      if (this.tierId != null) {
        posthog.group("tier", this.tierId.toString(), {
          id: this.tierId,
          name: this.team,
        });
      }

      // Notification.requestPermission();
    }

    this.tierLicense$ = (
      this.isMaster ? this.tierService.getTierLicense() : of(null)
    ).pipe(
      map((data) => {
        if (!data) {
          return null;
        }
        if (data.available_slots == -1) {
          return null;
        }
        return data;
      }),
      shareReplay()
    );

    this.allowNewTier$ = this.tierLicense$.pipe(
      map((license) => {
        return (
          license &&
          license.available_slots > license.used_slots &&
          license.tiers.every((e) => e.blocking)
        );
      })
    );

    this.tierList$ = this.refreshTierData.pipe(
      switchMap(() => {
        return combineLatest([
          this.userService.listTiers(0, true),
          this.tierLicense$,
        ]);
      }),
      map(([data, license]) => {
        data.tiers.sort((a, b) => {
          return a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : a.name.toLowerCase() === b.name.toLowerCase()
            ? 0
            : -1;
        });
        const licenseMap = new Map(
          ((license && license.tiers) || []).map((e) => [e.id, e])
        );
        const ownedTiersCount = data.tiers.filter(t => t.is_owner).length;
        return {
          tiers: data.tiers.map((e) => {
            this.defaultTier = e.is_default ? e.id : this.defaultTier;
            const l = licenseMap.get(e.id);
            return {
              ...e,
              member_count: l ? l.member_count : null,
            };
          }),
          freeAvailable: data.freeAvailable,
          ownedTiersCount: ownedTiersCount,
        };
      })
    );

    this.mySubText$ = of(null).pipe(
      mergeMap(() => {
        return from(this.licenseService.currentSubscription());
      }),
      map((data) => {
        if (!data.has) {
          return this.translateService.instant("no_license");
        }
        let t = data.license_type;
        if (data.quantity > 1) {
          t += ` [${data.quantity}]`;
        }
        return t;
      })
    );

    // this.getAds();
    /* this.getNotifications();
    setInterval(() => this.getNotifications(), 60e3); */

    this.organizeMenuItems();

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.navItems.forEach((item) => {
        item.name = this.translateService.instant(item.i18nkey);
      });
      this.navItems = JSON.parse(JSON.stringify(this.navItems));
    });

    await this.initNotificationOptions();
    this.modalHiddenSub = this.modalService.onHidden.subscribe(() => {
      this.shareModal = null;
    });

    this.loadChatScript();

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.shouldLoadChatOnCurrentPage() && !this.chatScriptLoaded) {
          this.loadChatScript();
        }
      }
    });
    this.unsubList.push(() => routerSubscription.unsubscribe());
  }

  ngAfterViewInit() {
    const modalContent = document.querySelector('.modal-content');
    if (modalContent) {
      (modalContent as HTMLElement).style.transform = 'none';
    }
  }

  ngOnDestroy(): void {
    this.unsubList.forEach((e) => e());
    if (Native.IsMainWindow()) {
      Native.setDecoration(true);
    }
    if (this.modalHiddenSub) {
      this.modalHiddenSub.unsubscribe();
    }
    if (this.offlineBannerSub) {
      this.offlineBannerSub.unsubscribe();
    }
  }

  async handlePlayTournamentEvent(payload: any) {
    if (!this.userData || !this.userData.id) {
      return;
    }

    const userId = this.userData.id;
    await GrindModeLocalStorage.initialize(userId);

    let playListL: any[] = GrindModeLocalStorage.getUserList(userId, 'play', []);

    const tournamentId = payload.iD;
    const existingTournament = playListL.find((entry) => entry.id === tournamentId);
    const alreadyExists = playListL.some(
      t => t.id === tournamentId
    );

    const t = payload.tournament || {};

    let startStr = "";
    if (t.start && typeof t.start === "object" && typeof t.start.seconds === "number") {
      startStr = new Date(t.start.seconds * 1000).toISOString();
    } else if (typeof t.start === "string") {
      startStr = t.start;
    }

    // Prepare metadata if missing
    let metadata = t.metadata ?? null;
    if (metadata == null) {
      metadata = {
      PSTART: startStr,
      FAVORITE: false
      };
    }

    const newPlayedTime = new Date().toISOString();

    const newTournament = {
      id: payload.iD,
      tournament_id: t.iD,
      status: "playing",
      playing: true,
      site: t.siteID,
      buy_in: t.buyIn,
      late_register: t.lateRegister,
      name: t.name,
      start: startStr,
      played_time: existingTournament?.played_time ?? newPlayedTime,
      current_blind: t.currentBlind,
      rebuy: t.rebuy ?? 0,
      add_on: t.add_on ?? 0,
      notification: t.notification,
      original_buy_in: t.original_buy_in ?? t.buyIn,
      custom_buy_in: t.custom_buy_in ?? null,
      average_duration: t.averageDuration,
      priority: payload.priority ?? t.priority,
      field: t.field,
      keepOnPlayList: false,
      variant: t.variant,
      prize_pool: t.prizePool,
      speed: t.speed,
      players: t.players,
      metadata: metadata,
      currency: t.currency,
      av_ability: t.av_ability ?? 0,
      game: t.game ?? 0,
      can_open_lobby: t.can_open_lobby ?? false,
      color: t.color ?? null,
      end_pos: null,
      native_id: t.native_id ?? null
    };

    if(!alreadyExists) {
      playListL.push(newTournament);

      GrindModeLocalStorage.setUserList(userId, 'play', playListL);
      localStorage.setItem("refresh-schedules", "true");
    }

    await this.statsService.updateStats({
      id: newTournament.tournament_id,
      played: newTournament.playing,
      time: newTournament.start,
      play_time: newTournament.played_time,
      rebuy: newTournament.rebuy ?? 0,
      add_on: newTournament.add_on ?? 0,
      end_pos: newTournament.end_pos ?? null
    }).toPromise();
  }

  private async initNotificationOptions() {
    if (Native.IsNative()) {
      try {
        const local = localStorage.getItem("notifications-options");
        const store = await Store.load("config.json");
        const stored = await store.get("notifications-options");
        const storedBehavior = await store.get("close-window-behavior");

        if (storedBehavior && (storedBehavior === 'tray' || storedBehavior === 'close')) {
          this.closeWindowBehavior = storedBehavior;
        }

        const source = pickNotificationOptionsSource(stored, local);
        if (source === "stored") {
          this.notificationOptions = { ...this.defaultNotificationOptions, ...(stored as object) };
        } else if (source === "local") {
          try {
            const localOptions = JSON.parse(local as string);
            this.notificationOptions = { ...this.defaultNotificationOptions, ...localOptions };
          } catch (error) {
            console.error("Failed to parse localStorage notifications-options:", error);
            this.notificationOptions = { ...this.defaultNotificationOptions };
          }
        } else {
          this.notificationOptions = { ...this.defaultNotificationOptions };
        }

        localStorage.setItem("notifications-options", JSON.stringify(this.notificationOptions));
        await store.set("notifications-options", this.notificationOptions);
        await store.set("close-window-behavior", this.closeWindowBehavior);
        await store.save();
        await new Promise(resolve => setTimeout(resolve, 50));
        await emit("store-updated", { key: "notifications-options" });
      } catch (error) {
        console.error("Tauri store operation failed:", error);
      }
    }

    this.notificationOptions.badges = {
      ...this.defaultNotificationOptions.badges,
      ...this.notificationOptions.badges
    };

    const allBadgeKeys = Object.keys(this.defaultNotificationOptions.badges);
    if (!this.notificationOptions.badges_order || !Array.isArray(this.notificationOptions.badges_order)) {
      this.notificationOptions.badges_order = [...this.defaultNotificationOptions.badges_order];
    } else {
      const missingKeys = allBadgeKeys.filter(key => !this.notificationOptions.badges_order.includes(key));
      this.notificationOptions.badges_order = [...this.notificationOptions.badges_order, ...missingKeys];
    }

    if (this.notificationOptions.auto_close_late_reg === undefined) {
      this.notificationOptions.auto_close_late_reg = this.defaultNotificationOptions.auto_close_late_reg;
    }

    this.initializeBadgeItems();
  }

  async selectTier(tier: Tier) {
    const tierId = tier.id.toString();
    Cookies.set("tier", tierId);
    publishSessionContext({ tierId: tier.id });
    localStorage.removeItem("sites-true");
    localStorage.removeItem("sites-false");

    try {
      const previousIsMaster = this.isMaster;

      await this.getCurrentUser();

      if (this.isMaster !== previousIsMaster) {
        const targetRoute = this.isMaster ? '/tournaments' : '/scheduled-tournaments';
        window.location.href = targetRoute;
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error switching tier:', error);
      window.location.reload();
    }
  }

  isInputDeletionValid() {
    const lang = this.translateService.currentLang;

    if (lang == "pt-BR") {
      if (this.confirmDeletionText.toUpperCase() == "CONFIRMAR") {
        return true;
      }
    } else {
      if (this.confirmDeletionText.toUpperCase() == "CONFIRM") {
        return true;
      }
    }

    return false;
  }

  async setDefaultTier(tier) {
    const originalDefault = this.defaultTier;
    this.defaultTier = tier.id;
    try {
      await this.userService.setDefaultTier(tier.id).toPromise();
      this.showSnackMessage(
        this.translateService.instant("default_tier_changed")
      );
    } catch (e) {
      this.defaultTier = originalDefault;
      this.showSnackMessage(
        this.translateService.instant("Something went wrong!")
      );
      console.log(e);
    }
  }

  async onClickDeleteTier() {
    try {
      this.spinner.show();
      await this.tierService.deleteTier(this.tierToDelete.id).toPromise();
      const currTier = Number(Cookies.get("tier"));
      if (currTier == this.tierToDelete.id) {
        var tiers = await this.userService.listTiers(0).toPromise();
        this.selectTier(tiers[0]);
      } else {
        window.location.reload();
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.spinner.hide();
    }
  }

  get isCreateNewTierInvalid(): boolean {
    return this.newTierName == null || this.newTierName.length <= 0;
  }

  async createNewTier() {
    if (this.newTierName == null || this.newTierName.length <= 0) {
      return;
    }
    try {
      this.spinner.show();

      const name = this.newTierName;

      const newTier: any = await this.tierService.createTier(name).toPromise();

      this.selectTier(newTier.tier);
    } finally {
      this.spinner.hide();
    }
  }

  executeMasterGuide(): void {
    this.guideTour.defaultStepOptions = tour.defaultStepOptions;
    this.guideTour.modal = true;
    this.guideTour.confirmCancel = false;
    this.guideTour.addSteps(tour.steps);
    this.guideTour.start();
  }

  executeNonMasterGuide(): void {
    var tourAux = { ...tour };
    if (this.router.url == "/tournaments") {
      tourAux.steps.forEach((element, index) => {
        if (element.id == "tournaments-page") tourAux.steps.splice(index, 1);
      });
    }

    tourAux.steps.map((e) => {
      e.text = this.translateService.instant(e.i18n_text);
      e.title = this.translateService.instant(e.i18n_title);
      _map(e.buttons, (b) => {
        if (b["i18n"]) {
          b["text"] = this.translateService.instant(b["i18n"]);
        }
      });
    });

    this.guideTour.defaultStepOptions = tourAux.defaultStepOptions;
    this.guideTour.modal = true;
    this.guideTour.confirmCancel = false;
    this.guideTour.addSteps(tourAux.steps);
    this.guideTour.start();
  }

  executeRebalanceGuide(): void {
    var tourAux = { ...tourRebalance };
    if (this.router.url == "/rebalance") {
      tourAux.steps.forEach((element, index) => {
        if (element.id == "rebalance-page") tourAux.steps.splice(index, 1);
      });
    }

    tourAux.steps.map((e) => {
      e.text = this.translateService.instant(e.i18n_text);
      e.title = this.translateService.instant(e.i18n_title);
      _map(e.buttons, (b) => {
        if (b["i18n"]) {
          b["text"] = this.translateService.instant(b["i18n"]);
        }
      });
    });

    this.guideTour.defaultStepOptions = tourAux.defaultStepOptions;
    this.guideTour.modal = true;
    this.guideTour.confirmCancel = false;
    this.guideTour.addSteps(tourAux.steps);
    this.guideTour.start();
  }

  executeManageFiltersGuide(): void {
    var tourAux = { ...tourManageFilters };
    if (this.router.url == "/manage-filters") {
      tourAux.steps.forEach((element, index) => {
        if (element.id == "manage-filters-page") tourAux.steps.splice(index, 1);
      });
    }

    tourAux.steps.map((e) => {
      e.text = this.translateService.instant(e.i18n_text);
      e.title = this.translateService.instant(e.i18n_title);
      _map(e.buttons, (b) => {
        if (b["i18n"]) {
          b["text"] = this.translateService.instant(b["i18n"]);
        }
      });
    });

    this.guideTour.defaultStepOptions = tourAux.defaultStepOptions;
    this.guideTour.modal = true;
    this.guideTour.confirmCancel = false;
    this.guideTour.addSteps(tourAux.steps);
    this.guideTour.start();
  }

  changeTableZoom(amount: number) {
    let newZoom = this.tableZoom + amount;
    if (newZoom < 0.5) {
      newZoom = 0.5;
    } else if (newZoom > 2) {
      newZoom = 2;
    }

    this.tableZoom = Math.round(newZoom * 10) / 10;
    localStorage.setItem("table-zoom", this.tableZoom.toFixed(1));
  }

  setTimeFormat(format: TimeFormatPreference) {
    if (this.timeFormat === format) {
      return;
    }

    this.timeFormat = format;
    setUserTimeFormatPreference(format);
  }

  searchCheck(name: string): boolean {
    return name.toUpperCase().startsWith(this.tierSearch.toUpperCase());
  }

  // Mantém apenas um construtor e a função toggleUITheme
  toggleUITheme() {
    this.isDarkTheme = document.body.classList.toggle("dark-theme");
    Cookies.set("theme-ui", this.isDarkTheme.toString(), { expires: 365 });
    this.themeService.setDarkTheme(this.isDarkTheme);
  }

  isShopPage() {
    const path = window.location.pathname;
    return path === "/buy" || path.startsWith("/buy/");
  }

  async openSubscription() {
    this.spinner.show();
    try {
      const license = await this.licenseService.currentSubscription();
      if (license.has) {
        location.assign(await this.licenseService.subscriptionPortal(location.href));
      } else {
        this.router.navigate(["/buy"]);
        this.spinner.hide();
      }
    } catch (e) {
      this.spinner.hide();
    }
  }

  titleAction(action: string) {
    if (!this.showTitleBar) {
      return;
    }
    const window = getCurrentWindow();
    if (action === "minimize") {
      window.minimize();
    } else if (action == "maximize") {
      window.toggleMaximize();
    } else if (action == "close") {
      window.close();
    }
  }

  installUpdate() {
    NativeUpdater.installUpdate();
  }

  async leaveTier() {
    try {
      this.spinner.show();
      const tier_id = this.tierToDelete.id;
      await this.tierService.leaveTier(tier_id);
      this.refreshTierData.next();
      this.toastService.success("You left the tier");
      if (tier_id === this.tierId) {
        window.location.reload();
      }
    } catch (e) {
      this.toastService.error(
        e?.error?.error || e?.message || JSON.stringify(e)
      );
    } finally {
      this.spinner.hide();
    }
  }

  async joinFreeTiers() {
    try {
      this.spinner.show();
      await this.userService.joinFreeTiers();
      this.refreshTierData.next();
      this.toastService.success("You received the new tiers");
    } catch (e) {
      this.toastService.error(
        e?.error?.error || e?.error || e?.message || JSON.stringify(e)
      );
    } finally {
      this.spinner.hide();
    }
  }

  openNotificationOptionsModal() {
    if (!this.shareModal) {
      this.toggleModal(this.modalNotificationOptions);
    }
  }

  openPreferencesModal() {
    if (!this.shareModal) {
      this.toggleModal(this.modalPreferences);
    }
  }

  openExternal(event: MouseEvent, url: string) {
    openNativeExternal(event, url);
  }

  private shareModal: BsModalRef;
  toggleModal(template?: TemplateRef<any>, modalClass?: string) {
    if (template) {
      this.shareModal = this.modalService.show(
        template,
        modalClass ? { class: modalClass } : undefined
      );
    } else if (this.shareModal != null) {
      this.shareModal.hide();
      this.shareModal = null;
    }
  }

  toggleModalStructure(template?: TemplateRef<any>, size: string = "modal-md") {
    if (template) {
      this.structureModal = this.modalService.show(template, { class: size });
    } else if (this.structureModal != null) {
      this.structureModal.hide();
    }
  }

  openEditFromNotification(payload: any) {
    const id = Number(payload?.id ?? payload?.iD);
    if (!Number.isFinite(id) || id <= 0) {
      return;
    }

    const tournamentId = Number(payload?.tournament?.id ?? payload?.tournament?.iD);
    this.editingScheduleId = id;
    this.editingTournamentId =
      Number.isFinite(tournamentId) && tournamentId > 0 ? tournamentId : null;
    this.editingScheduleName =
      payload?.tournament?.name ?? payload?.tournament?.Name ?? "";
    this.editingInitStacks = Number(
      payload?.tournament?.initialStack ?? payload?.tournament?.InitialStack
    );
    if (!Number.isFinite(this.editingInitStacks)) {
      this.editingInitStacks = null;
    }

    this.registerSetNotification = false;
    this.setRegTimeFromNotification = true;
    this.notificationTimeChanged = false;
    this.editingIds = this.editingTournamentId ? [this.editingTournamentId] : [];
    this.schComment = "";
    this.registerTime = null;
    this.originalRegisterTime = null;
    this.maxRebuy = null;
    this.registerTimeMap = {};

    this.updateNotifcationConfigSubject.next([id]);
    setTimeout(() => this.toggleModal(this.editNotificationModal, "modal-md"), 0);
  }

  showNotification(arr1: Array<number>, arr2: Array<number>) {
    return JSON.stringify(arr1) == JSON.stringify(arr2);
  }

  addNotification(notis: Array<object>, schedules: Array<number>) {
    notis.push({
      ids: null,
      schedules: schedules,
      notification: null,
      notification_type: "none",
    });
  }

  clearNotifications(notis: Array<any>) {
    notis.map((not) => {
      not.notification_type = "none";
      not.notification = 0;
    });
    this.setNotificationAsRegisterTime(notis);
  }

  hasNotifications(notis: Array<any>, ids: Array<number>) {
    const schedules = [];
    notis.map((not) => {
      schedules.push(...not.schedules);
    });
    return schedules.some((item) => ids.includes(item));
  }

  setRegisterAsNotification(notis: Array<object>, schedules: Array<number>) {
    if (this.registerSetNotification) {
      notis.push({
        ids: null,
        schedules: schedules,
        notification: this.registerTime,
        notification_type: "at",
      });
    }
  }

  removeAutoPriority(data) {
    if (data.priority >= 1000) {
      data.priority = data.priority - 1000;
    }
  }

  checkValidRebuy() {
    setTimeout(() => {
      if (this.maxRebuy != null) {
        this.maxRebuy = String(this.maxRebuy).replace(/\D/g, "");
      }
    }, 1000);
  }

  getNotificationTime(unix) {
    const milliseconds = Math.abs(unix) * 1000;
    const dateObject = new Date(milliseconds);
    const hours = dateObject.getHours();
    const minutes = "0" + dateObject.getMinutes();
    return hours + ":" + minutes.substr(-2);
  }

  async setNotificationAsRegisterTime(notis: Array<object>) {
    clearTimeout(this.regTimeDebouncer);
    this.regTimeDebouncer = setTimeout(async () => {
      if (this.setRegTimeFromNotification) {
        this.notificationTimeChanged = false;
        this.registerTimeMap = {};
        const latestNoti: any = JSON.parse(JSON.stringify(notis.slice(-1)[0]));

        if (latestNoti.notification_type && latestNoti.notification_type != "none") {
          if (latestNoti.notification_type == "at") {
            if (latestNoti.notification == 0) {
              latestNoti.notification_type = "none";
              this.registerTime = this.originalRegisterTime;
              this.registerTimeMap = {};
              this.notificationTimeChanged = false;
            } else {
              this.registerTime = latestNoti.notification;
              if (this.editingScheduleId) {
                this.registerTimeMap[this.editingScheduleId] = latestNoti.notification;
              }

              const d = new Date();
              d.setHours(parseInt(latestNoti.notification.toString().split(":")[0]));
              d.setMinutes(parseInt(latestNoti.notification.toString().split(":")[1]), 0, 0);
              const atNotification = Math.floor(d.getTime() / 1000);
              const payload = this.editingIds.map((e) => ({
                tournament: e,
                notification: atNotification,
                notification_type: latestNoti.notification_type,
                anticipate_notification: true,
              }));

              if (payload.length > 0) {
                const res: any = await this.notificationService
                  .getNotificationTime(payload)
                  .toPromise();
                this.notificationTimeChanged = !!(
                  res.anticipated_tournaments && res.anticipated_tournaments.length > 0
                );
              }
            }
          } else {
            if (latestNoti.notification_type == "at-blind") {
              if (latestNoti.notification == 0) {
                latestNoti.notification_type = "none";
              } else if (Number.isInteger(latestNoti.notification)) {
                latestNoti.notification = latestNoti.notification * 100;
              } else {
                latestNoti.notification = Number(
                  (latestNoti.notification * 100).toFixed(1)
                );
              }
            }

            const payload = this.editingIds.map((e) => ({
              tournament: e,
              notification: latestNoti.notification,
              notification_type: latestNoti.notification_type,
              anticipate_notification: true,
            }));

            if (payload.length === 0) {
              return;
            }

            const res: any = await this.notificationService
              .getNotificationTime(payload)
              .toPromise();
            if (res) {
              this.notificationTimeChanged = !!(
                res.anticipated_tournaments && res.anticipated_tournaments.length > 0
              );
              const times = [];
              for (const [key, value] of Object.entries(res)) {
                if (key === "time_changed") {
                  continue;
                }
                const unixTime = Number(value);
                if (!Number.isFinite(unixTime)) {
                  continue;
                }
                const time = new Date(unixTime * 1000);
                const regTime =
                  time.getHours().toString().padStart(2, "0") +
                  ":" +
                  time.getMinutes().toString().padStart(2, "0");
                if (this.editingScheduleId) {
                  this.registerTimeMap[this.editingScheduleId] = regTime;
                }
                if (!times.includes(regTime)) {
                  times.push(regTime);
                }
              }
              this.registerTime = times.length === 1 ? times[0] : null;
            } else {
              this.notificationTimeChanged = false;
            }
          }
        } else {
          this.registerTime = this.originalRegisterTime;
          this.registerTimeMap = {};
          this.notificationTimeChanged = false;
        }
      } else {
        this.registerTime = this.originalRegisterTime;
        this.registerTimeMap = {};
        this.notificationTimeChanged = false;
      }
    }, 500);
  }

  async openStructureSelect(data: any, notis: any) {
    this.currNotis = notis;
    this.structures = [];
    this.toggleModalStructure(this.modalBlinds);
    this.selectedNot = data;
    if (!this.editingTournamentId) {
      this.structures = [];
      return;
    }
    const blinds: any = await this.tournamentService
      .getBlindByIds([this.editingTournamentId])
      .toPromise();
    this.structures = Array.isArray(blinds?.blinds) ? blinds.blinds : [];
    this.selectedStructure = this.structures[0];
    if (this.selectedStructure) {
      this.selectedStructure.schedule_id = this.editingScheduleId;
      if (this.editingInitStacks && this.selectedStructure.data?.levels) {
        this.selectedStructure.data.levels.map((e) => {
          const val = this.editingInitStacks / e.blinds;
          e.init_blind = Number.isInteger(val) ? val : Number(val.toFixed(1));
        });
      }
    }
  }

  isCurrentLevel(_blind, _scheduleId) {
    return false;
  }

  onClickStructure(_details, i) {
    this.currentIndexStructure = i;
    this.selectedStructure = { ...this.structures[i] };
  }

  selectBlind(blind: number) {
    this.selectedNot.notification = Number(blind);
    this.setNotificationAsRegisterTime(this.currNotis);
    this.toggleModalStructure();
  }

  async onClickUpdateSchedule(
    {
      data,
      id_list,
    }: {
      data: any;
      id_list: number[];
    },
    second_run: boolean = false
  ) {
    try {
      this.spinner.show();
      this.toggleModal();

      if (second_run) {
        data = this.updatingSchedule.data;
        id_list = this.updatingSchedule.id_list;
      } else {
        this.updatingSchedule.data = data;
        this.updatingSchedule.id_list = id_list;
      }

      data.priority = +data.priority;

      if (data.notifications) {
        data.notifications.map((e) => {
          e.replicate = this.replicateNotification;
          e.anticipate_notification = true;
          if (e.notification_type == "at") {
            const d = new Date();
            d.setHours(parseInt(e.notification.toString().split(":")[0]));
            d.setMinutes(parseInt(e.notification.toString().split(":")[1]), 0, 0);
            e.notification = Math.floor(d.getTime() / 1000);
          } else if (e.notification_type == "at-blind") {
            if (e.notification == 0) {
              e.notification_type = "none";
            } else if (!second_run) {
              if (Number.isInteger(e.notification)) {
                e.notification = e.notification * 100;
              } else {
                e.notification = Number((e.notification * 100).toFixed(1));
              }
            }
          }
          delete e["ids"];
        });
      }

      await this.notificationService.updateScheduleNotification(data.notifications).toPromise();

      if (data.priority && this.isMaster) {
        await this.scheduleService
          .updateSchedule(id_list, data.priority, this.replicatePriority)
          .toPromise();
      }

      if (this.registerTime) {
        const [hour, min] = this.registerTime.split(":");
        const timePayload = parseInt(hour) * 60 + parseInt(min);
        await this.scheduleService
          .saveRegisterTime(id_list, timePayload, this.registerReflectAll)
          .toPromise();
      } else if (Object.keys(this.registerTimeMap).length > 0) {
        for (const [key, value] of Object.entries(this.registerTimeMap)) {
          const [hour, min] = value.split(":");
          const timePayload = parseInt(hour) * 60 + parseInt(min);
          await this.scheduleService
            .saveRegisterTime([Number(key)], timePayload, this.registerReflectAll)
            .toPromise();
        }
      }

      await this.scheduleService
        .saveComment(id_list, this.schComment, this.commentReflectAll)
        .toPromise();

      if (this.isMaster) {
        if (this.maxRebuy == null || this.maxRebuy == "") {
          this.maxRebuy = -1;
        }
        if (this.maxRebuy != "Unchanged") {
          await this.scheduleService
            .saveMaxRebuy(id_list, Number(this.maxRebuy), this.maxRebuyReflectAll)
            .toPromise();
        }
      }

      this.updatingSchedule = { data: {}, id_list: [] };
    } catch (e) {
      console.log(e);
      this.toastService.error(
        e?.error?.error || e?.error || e?.message || "Failed to update notification"
      );
    } finally {
      this.spinner.hide();
    }
  }

  private shouldLoadChatOnCurrentPage(): boolean {
    const currentPath = this.router.url.split(/[?#]/)[0];

    return !this.chatDisabledPages.some((page) => {
      const normalized = page.startsWith('/') ? page : `/${page}`;
      return (
        currentPath === normalized ||
        currentPath.startsWith(`${normalized}/`)
      );
    });
  }

  public loadChatScript(): void {
    if (this.chatScriptLoaded || !this.shouldLoadChatOnCurrentPage()) {
      return;
    }

    this.chatScriptLoaded = true;

    try {
      if (!(window as any).chatbase || (window as any).chatbase("getState") !== "initialized") {
        (window as any).chatbase = (...args: any[]) => {
          if (!(window as any).chatbase.q) {
            (window as any).chatbase.q = [];
          }
          (window as any).chatbase.q.push(args);
        };

        (window as any).chatbase = new Proxy((window as any).chatbase, {
          get(target: any, prop: any) {
            if (prop === "q") {
              return target.q;
            }
            return (...args: any[]) => target(prop, ...args);
          }
        });
      }

      const onLoad = () => {
        const script = document.createElement('script');
        script.src = this.chatConfig.scriptUrl;
        script.id = this.chatConfig.chatbotId;
        script.setAttribute('domain', this.chatConfig.domain);
        document.body.appendChild(script);
      };

      if (document.readyState === "complete") {
        onLoad();
      } else {
        window.addEventListener("load", onLoad, { once: true });
      }
    } catch (error) {
      this.chatScriptLoaded = false;
      console.error('Failed to load chat script:', error);
    }
  }

  public openHelpChat(event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    if (!this.shouldLoadChatOnCurrentPage()) {
      return;
    }

    if (!this.chatScriptLoaded) {
      this.loadChatScript();
    }

    this.openChatWithRetry();
  }

  public async openStarterWizard(event?: Event): Promise<void> {
    if (event) {
      event.preventDefault();
    }

    if (this.bloquedFunctions) {
      this.showSnackMessage(this.translateService.instant("starter_wizard_requires_license"));
      return;
    }

    if (!(await this.ensureCanCreateTier())) {
      return;
    }

    this.resetStarterWizard();
    await this.loadStarterWizardSiteOptions();
    this.shareModal = this.modalService.show(this.modalStarterWizard, {
      class: "modal-xl starter-wizard-modal",
      ignoreBackdropClick: true,
    });
  }

  public resetStarterWizard(): void {
    this.starterWizardStep = 0;
    this.starterWizardLoading = false;
    this.starterWizardDone = false;
    this.starterWizardCreatedFilterName = "";
    this.starterWizardCreatedTier = null;
    this.starterWizardAnswers = {
      siteIds: [],
      buyInMin: null,
      buyInMax: null,
      prizePoolMin: null,
      prizePoolMax: null,
      speeds: [],
      players: [],
      types: [],
      variants: [],
      weekDays: [],
    };
  }

  public async loadStarterWizardSiteOptions(): Promise<void> {
    if (this.starterWizardSiteOptions.length > 0) {
      return;
    }

    try {
      const helper = await this.siteService.getSitesHelpers(false).pipe(take(1)).toPromise();
      const sites = Array.isArray(helper?.sites) ? helper.sites : [];
      this.starterWizardSiteOptions = sites
        .map((site) => ({ id: site.id, name: site.name }))
        .sort((a, b) => a.name.localeCompare(b.name));
    } catch (error) {
      console.error("Could not load starter wizard sites", error);
      this.starterWizardSiteOptions = [];
    }
  }

  public toggleStarterSite(siteId: number): void {
    if (this.starterWizardAnswers.siteIds.includes(siteId)) {
      this.starterWizardAnswers.siteIds = this.starterWizardAnswers.siteIds.filter((id) => id !== siteId);
      return;
    }
    this.starterWizardAnswers.siteIds = [...this.starterWizardAnswers.siteIds, siteId];
  }

  public toggleStarterOption(option: string, field: "speeds" | "players" | "types" | "variants"): void {
    const currentValues = this.starterWizardAnswers[field] as string[];
    if (currentValues.includes(option)) {
      this.starterWizardAnswers[field] = currentValues.filter((value) => value !== option) as any;
      return;
    }
    this.starterWizardAnswers[field] = [...currentValues, option] as any;
  }

  public toggleStarterWeekDay(day: number): void {
    if (this.starterWizardAnswers.weekDays.includes(day)) {
      this.starterWizardAnswers.weekDays = this.starterWizardAnswers.weekDays.filter((value) => value !== day);
      return;
    }
    this.starterWizardAnswers.weekDays = [...this.starterWizardAnswers.weekDays, day].sort((a, b) => a - b);
  }

  public canGoToNextStarterStep(): boolean {
    if (this.starterWizardStep === 1) {
      return this.starterWizardAnswers.siteIds.length > 0;
    }
    if (this.starterWizardStep === 2) {
      const min = this.starterWizardAnswers.buyInMin;
      const max = this.starterWizardAnswers.buyInMax;
      if (min == null && max == null) {
        return false;
      }
      if (min != null && max != null) {
        return min <= max;
      }
      return true;
    }
    if (this.starterWizardStep === 3) {
      const min = this.starterWizardAnswers.prizePoolMin;
      const max = this.starterWizardAnswers.prizePoolMax;
      if (min != null && max != null) {
        return min <= max;
      }
      return min != null || max != null;
    }
    if (this.starterWizardStep === 5) {
      return this.starterWizardAnswers.weekDays.length > 0;
    }
    return true;
  }

  public nextStarterStep(): void {
    if (!this.canGoToNextStarterStep()) {
      return;
    }
    if (this.starterWizardStep < this.starterWizardTotalSteps) {
      this.starterWizardStep += 1;
    }
  }

  public previousStarterStep(): void {
    if (this.starterWizardStep > 0) {
      this.starterWizardStep -= 1;
    }
  }

  public async completeStarterWizard(): Promise<void> {
    try {
      this.starterWizardLoading = true;

      if (!(await this.ensureCanCreateTier())) {
        return;
      }

      const generatedName = `Starter ${new Date().toLocaleDateString()}`;
      const siteMap = new Map(this.starterWizardSiteOptions.map((s) => [s.id, s.name]));

      const filterData: any = {
        id: 0,
        name: generatedName,
        site: this.starterWizardAnswers.siteIds.map((id) => ({
          item_id: id,
          item_text: siteMap.get(id) || `Site ${id}`,
        })),
        game2: null,
        buy_in_min: this.starterWizardAnswers.buyInMin != null ? String(this.starterWizardAnswers.buyInMin) : null,
        buy_in_max: this.starterWizardAnswers.buyInMax != null ? String(this.starterWizardAnswers.buyInMax) : null,
        speed: this.starterWizardAnswers.speeds.map((speed) => ({ item_id: speed, item_text: speed })),
        type: this.starterWizardAnswers.types.map((type) => ({ item_id: type, item_text: type })),
        players: this.starterWizardAnswers.players.map((players) => ({ item_id: players, item_text: players })),
        variant: this.starterWizardAnswers.variants.map((variant) => ({ item_id: variant, item_text: variant })),
        state: null,
        prize_pool_min: this.starterWizardAnswers.prizePoolMin,
        prize_pool_max: this.starterWizardAnswers.prizePoolMax,
        init_stacks_min: null,
        init_stacks_max: null,
        from_date: null,
        to_date: null,
        from_time: null,
        to_time: null,
        search: "",
        order: { state: 1 },
        onlyNew: false,
        scheduled: null,
        maxLate: false,
        field: null,
        from_duration: null,
        priority: null,
        to_duration: null,
        limit: null,
        include_closed: false,
        order_start: 0,
        order_site: 0,
        order_game: 0,
        order_buy_in: 0,
        order_name: 0,
        order_prize_pool: 0,
        order_speed: 0,
        order_state: 1,
        order_field: 0,
        order_duration: 0,
        order_register_time: 0,
        order_av_ability: 0,
        order_type: 0,
        onlyFast: false,
        from_register_time: null,
        to_register_time: null,
        timezone: -new Date().getTimezoneOffset(),
        exclude: "",
        flagged_only: null,
        auto_scheduled_only: null,
        show_exception: false,
        category: null,
        av_ability_min: null,
        av_ability: null,
        favorites: null,
        currency: null,
        min_participants: null,
        week_day: this.starterWizardAnswers.weekDays.map((day) => ({
          item_id: day,
          item_text: this.translateService.instant(this.starterWeekDayOptions.find((d) => d.id === day)?.key || `Day ${day}`),
        })),
        from_end_time: null,
        to_end_time: null,
        order_grindstate: 0,
        order_priority: 0,
        auto_only: true,
        manual_only: false,
        deleted_filter_only: true,
        unchecked_filter_only: false,
        min_blind: null,
        max_blind: null,
        notifications: null,
      };

      const created: any = await this.tierService.createTier(generatedName).toPromise();
      const newTier: Tier | undefined = created?.tier;
      if (!newTier?.id) {
        throw new Error("createTier did not return a tier");
      }

      const previousTierCookie = this.activateTierForRequests(newTier.id);
      try {
        await this.userService
          .updateUserFilter([
            {
              id: 0,
              data: filterData,
              auto_schedule: true,
              priority: 5,
            },
          ])
          .toPromise();

        await this.tierService.executeAutoScheduler().toPromise();
      } catch (error) {
        this.restoreTierForRequests(previousTierCookie);
        throw error;
      }

      this.starterWizardCreatedTier = newTier;
      this.team = newTier.name || generatedName;
      this.tierId = newTier.id;
      this.refreshTierData.next();
      this.starterWizardCreatedFilterName = generatedName;
      this.starterWizardDone = true;
      this.starterWizardStep = this.starterWizardTotalSteps;
      this.showSnackMessage(this.translateService.instant("starter_wizard_success"));

      if (this.shareModal == null) {
        await this.selectTier(newTier);
      }
    } catch (error) {
      console.error("Failed to complete starter wizard", error);
      this.showSnackMessage(this.translateService.instant("starter_wizard_error"));
    } finally {
      this.starterWizardLoading = false;
    }
  }

  public closeStarterWizard(): void {
    const createdTier = this.starterWizardDone ? this.starterWizardCreatedTier : null;
    this.toggleModal();
    if (createdTier) {
      void this.selectTier(createdTier);
    }
  }

  public goToScheduledTournamentsFromStarterWizard(): void {
    this.toggleModal();
    window.location.href = "/scheduled-tournaments";
  }

  private async ensureCanCreateTier(): Promise<boolean> {
    try {
      const allowed = await this.allowNewTier$.pipe(take(1)).toPromise();
      if (!allowed) {
        this.showSnackMessage(this.translateService.instant("tiers_must_have_4_users"));
        return false;
      }
      return true;
    } catch (error) {
      console.error("Failed to check whether a new tier can be created", error);
      this.showSnackMessage(this.translateService.instant("starter_wizard_error"));
      return false;
    }
  }

  private activateTierForRequests(tierId: number): string | undefined {
    const previousTierCookie = Cookies.get("tier");
    Cookies.set("tier", tierId.toString());
    NativeSharedStorage.setItem("tier_id", tierId.toString());
    publishSessionContext({ tierId });
    localStorage.removeItem("sites-true");
    localStorage.removeItem("sites-false");
    return previousTierCookie;
  }

  private restoreTierForRequests(previousTierCookie: string | undefined): void {
    if (previousTierCookie) {
      Cookies.set("tier", previousTierCookie);
      NativeSharedStorage.setItem("tier_id", previousTierCookie);
      const restored = parseInt(previousTierCookie, 10);
      publishSessionContext({ tierId: Number.isFinite(restored) ? restored : null });
      return;
    }
    Cookies.remove("tier", { domain: environment.BASE_COOKIE });
    publishSessionContext({ tierId: null });
  }

  private openChatWithRetry(attempt = 0): void {
    const chatWindow = document.getElementById('chatbase-bubble-window') as HTMLElement | null;
    if (chatWindow && chatWindow.style.display !== 'none') {
      return;
    }

    const chatbase = (window as any).chatbase;
    if (typeof chatbase === 'function') {
      try {
        chatbase('open');
      } catch (error) {
        console.error('Failed to open Chatbase via API:', error);
      }
    }

    const launcherButton = document.getElementById('chatbase-bubble-button') as HTMLElement | null;
    if (launcherButton) {
      launcherButton.click();
    }

    if (chatWindow) {
      chatWindow.style.display = 'flex';
      chatWindow.style.opacity = '1';
      chatWindow.style.visibility = 'visible';
      chatWindow.style.pointerEvents = 'auto';
    }

    if (attempt < 5) {
      window.setTimeout(() => {
        const currentChatWindow = document.getElementById('chatbase-bubble-window') as HTMLElement | null;
        if (!currentChatWindow || currentChatWindow.style.display === 'none') {
          this.openChatWithRetry(attempt + 1);
        }
      }, 250 * (attempt + 1));
    }
  }
}
